import React,{ Component } from "react";
import PropTypes from 'prop-types';
//material-ui design helpers


//material-ui core components
import { Typography } from "@mui/material";
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const s:any = {
  root: {
    borderBottom: `1px solid blue`,
    m: 0,
    p: 2,
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'grey[500]',
  },
};

class DialogClosableTitle extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  render(){
    const { children, classes, onClose } = this.props;
    return(
      <DialogTitle sx={{...s.root}}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" sx={{...s.closeButton}} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
    )
  }
}

DialogClosableTitle.propTypes = {
  onClose: PropTypes.func,
}

//DialogClosableTitle = withStyles(styles, { withTheme: true })(DialogClosableTitle);
export default DialogClosableTitle;